import React, { useEffect, useState } from "react";
import { IExpense } from "../../types/expense.type";
import useGetRequest from "../../hooks/useGetRequest";
import { api } from "../../api/api";
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Popconfirm,
  Space,
  Table,
  Typography,
} from "antd";
import { useAuth } from "../../contexts/auth.context";
import { UserRole } from "../../types/user.type";

const { Title } = Typography;

export default function Expenses() {
  const { authState } = useAuth();
  const [expenses, setExpenses] = useState<IExpense[]>([]);
  const { data, loading, refresh } = useGetRequest(`/expense`);
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (data) {
      setExpenses(data);
    }
  }, [data]);

  const handleSubmitForm = async (values: Partial<IExpense>) => {
    setConfirmLoading(true);

    try {
      await api.post("/expense", values);
      message.success("Расход успешно создан.");

      refresh();
      setIsModalOpen(false);
      setConfirmLoading(false);
      form.resetFields();
    } catch (error: any) {
      setConfirmLoading(false);
      console.error("Error creating expense", error);
      message.error(error.response.data.error);
    }
  };

  const handleDeleteExpense = async (expenseId: string) => {
    try {
      await api.delete(`/expense/${expenseId}`);
      message.success("Расход успешно удален.");
      refresh();
    } catch (error: any) {
      console.error("Error deleting expense", error);
      message.error(error.response.data.error);
    }
  };

  const columns = [
    { title: "Имя расхода", dataIndex: "name", key: "name" },
    { title: "Создал", dataIndex: "ownerName", key: "ownerName" },
    {
      title: "Дата",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt: string) => {
        const date = new Date(createdAt);
        const formattedDate = date.toLocaleDateString("ru-RU");
        return <p>{formattedDate}</p>;
      },
    },
    {
      title: "Действия",
      key: "actions",
      render: (_: any, expense: IExpense) => (
        <Space>
          {authState.user?.role === UserRole.Admin && (
            <Popconfirm
              title="Вы уверены, что хотите удалить этот расход?"
              onConfirm={() => handleDeleteExpense(expense._id)}
              okText="Да"
              cancelText="Нет"
            >
              <Button type="link" danger>
                Удалить
              </Button>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];
  return (
    <div style={{ padding: 24 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Title level={2}>Расходы</Title>
        {authState.user?.role === UserRole.Admin && (
          <Button
            type="primary"
            onClick={() => setIsModalOpen(true)}
            style={{ marginBottom: 16 }}
          >
            Добавить
          </Button>
        )}
      </div>
      <Table
        columns={columns}
        dataSource={expenses}
        rowKey={(record) => record._id}
        pagination={false}
        loading={loading}
      />
      <Modal
        title="Добавить расход"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => form.submit()}
        confirmLoading={confirmLoading}
      >
        <Form form={form} onFinish={handleSubmitForm} layout="vertical">
          <Form.Item
            name="name"
            label="Имя расхода"
            rules={[{ required: true, message: "Введите имя расхода" }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
